var map = {
	"./123.svg": 582,
	"./AI.svg": 585,
	"./Logo v.svg": 586,
	"./Logo-HR.svg": 587,
	"./Logo.svg": 588,
	"./Qanoniah-02.svg": 450,
	"./Qanoniah-AI-01.svg": 589,
	"./Qanoniah-AI-02.svg": 590,
	"./RatingStar.svg": 591,
	"./account-manager.svg": 592,
	"./ai-translation-fill.svg": 593,
	"./ai-translation.svg": 594,
	"./ai_logo.svg": 595,
	"./alert-circle.svg": 596,
	"./alert-triangle.svg": 597,
	"./android app store.svg": 598,
	"./arrow-down.svg": 599,
	"./arrow-left.svg": 600,
	"./arrow-narrow-up.svg": 601,
	"./arrow-right.svg": 602,
	"./arrow-up.svg": 603,
	"./arrows-left.svg": 604,
	"./bank.svg": 605,
	"./basic_logo.svg": 434,
	"./bell-ringing.svg": 606,
	"./bell.svg": 607,
	"./big-circular-check.svg": 608,
	"./book-open-01.svg": 609,
	"./books.svg": 610,
	"./briefcase.svg": 611,
	"./building-07.svg": 612,
	"./building.svg": 613,
	"./calendar-date.svg": 614,
	"./calendar-edit.svg": 615,
	"./calendar-plus-01.svg": 616,
	"./calendar.svg": 617,
	"./call-calling.svg": 618,
	"./certificate-01.svg": 619,
	"./check-circle.svg": 620,
	"./check.svg": 621,
	"./checkbox-checked-false.svg": 622,
	"./checkbox-checked-true.svg": 623,
	"./chevron-down.svg": 624,
	"./chevron-left.svg": 625,
	"./chevron-right.svg": 626,
	"./chevron-selector-vertical.svg": 627,
	"./chevron-up.svg": 628,
	"./clip-board.svg": 629,
	"./clipboard-check.svg": 630,
	"./clipboard-copy.svg": 631,
	"./clipboard-list.svg": 632,
	"./clock-plus.svg": 633,
	"./clock-rewind.svg": 634,
	"./clock.svg": 635,
	"./convert.svg": 636,
	"./copy-01.svg": 637,
	"./copy.svg": 638,
	"./credit-card-edit.svg": 639,
	"./danger.svg": 640,
	"./dislike.svg": 641,
	"./document-1-copy.svg": 642,
	"./document-1.svg": 643,
	"./document-search.svg": 644,
	"./document-text.svg": 645,
	"./documents.svg": 646,
	"./dollar-clock.svg": 647,
	"./dots-horizontal.svg": 648,
	"./dots-vertical.svg": 649,
	"./download.svg": 650,
	"./duplicate.svg": 651,
	"./edit-01.svg": 652,
	"./edit-05.svg": 653,
	"./edit-squire.svg": 654,
	"./edit.svg": 655,
	"./email.svg": 656,
	"./emoji-normal.svg": 657,
	"./eye-off.svg": 658,
	"./eye.svg": 659,
	"./facebook.svg": 660,
	"./file-02.svg": 661,
	"./file-04.svg": 662,
	"./file-check-02.svg": 663,
	"./file-download-02.svg": 664,
	"./file-lg.svg": 665,
	"./file-plus-03.svg": 666,
	"./file-upload-02.svg": 667,
	"./file-x-03.svg": 668,
	"./filter-funnel-01.svg": 669,
	"./filter-funnel.svg": 670,
	"./flip-backward.svg": 671,
	"./folder-01.svg": 672,
	"./folder-closed.svg": 673,
	"./folder-lg.svg": 674,
	"./folder-plus.svg": 675,
	"./folder-question.svg": 676,
	"./folder.svg": 677,
	"./gift-01.svg": 678,
	"./gift-02.svg": 679,
	"./gift.svg": 680,
	"./global.svg": 681,
	"./help-circle.svg": 682,
	"./home-02.svg": 683,
	"./home.svg": 684,
	"./info-circle.svg": 685,
	"./instgram.svg": 686,
	"./intercom.svg": 687,
	"./ios app store.svg": 688,
	"./key.svg": 689,
	"./like.svg": 690,
	"./link-external-01.svg": 691,
	"./link-external.svg": 692,
	"./linkedin-square.svg": 451,
	"./linkedin.svg": 693,
	"./loading.svg": 694,
	"./location.svg": 695,
	"./lock-01.svg": 696,
	"./lock-02.svg": 697,
	"./lock-unlocked.svg": 698,
	"./lock.svg": 699,
	"./logo h.svg": 700,
	"./logout.svg": 701,
	"./marker.svg": 702,
	"./maximize-01.svg": 703,
	"./medal-star.svg": 704,
	"./menu-01.svg": 705,
	"./menu.svg": 706,
	"./message-chat-square.svg": 707,
	"./message-plus-square.svg": 708,
	"./message-text-square-02.svg": 709,
	"./messages-linear.svg": 710,
	"./messages.svg": 711,
	"./minimize-01.svg": 712,
	"./minus-circle.svg": 713,
	"./minus.svg": 714,
	"./monitor.svg": 715,
	"./note.svg": 716,
	"./notification-filled.svg": 717,
	"./notification.svg": 718,
	"./numeric-range-1.svg": 719,
	"./numeric-range.svg": 720,
	"./official-translation.svg": 721,
	"./opened-folder.svg": 722,
	"./pencil-line.svg": 723,
	"./pencil.svg": 724,
	"./percentage.svg": 725,
	"./phone.svg": 726,
	"./play.svg": 727,
	"./plus-circle-filled.svg": 728,
	"./plus-circle.svg": 729,
	"./plus-square.svg": 730,
	"./plus.svg": 731,
	"./printer.svg": 732,
	"./profile-2user.svg": 733,
	"./qanoniah-ai-new.svg": 734,
	"./qanoniah-ai-vector.svg": 735,
	"./range.svg": 736,
	"./refresh-ccw-01.svg": 737,
	"./refresh-ccw.svg": 738,
	"./repeat-04.svg": 739,
	"./research.svg": 740,
	"./reverse-left.svg": 741,
	"./rocket-02.svg": 742,
	"./save.svg": 743,
	"./scales-01.svg": 744,
	"./scales.svg": 745,
	"./search-lg.svg": 746,
	"./search-md.svg": 747,
	"./search-normal.svg": 748,
	"./security-safe.svg": 749,
	"./send-01.svg": 750,
	"./send-03-left.svg": 751,
	"./send-03.svg": 752,
	"./setting.svg": 753,
	"./settings-02.svg": 754,
	"./settings.svg": 755,
	"./shield-tick.svg": 756,
	"./sidebar-left.svg": 757,
	"./sidebar-right.svg": 758,
	"./sms-01.svg": 759,
	"./sms-02.svg": 760,
	"./sms.svg": 761,
	"./star-01.svg": 762,
	"./star.svg": 763,
	"./suggestion-template-fold.svg": 764,
	"./tag-x-lg.svg": 765,
	"./tag.svg": 766,
	"./telegram.svg": 767,
	"./telescope.svg": 768,
	"./tick.svg": 769,
	"./ticket-01.svg": 770,
	"./timer-01.svg": 771,
	"./timer.svg": 772,
	"./trash-01.svg": 773,
	"./trash-02.svg": 774,
	"./trash.svg": 775,
	"./twitter-color.svg": 776,
	"./twitter-x.svg": 452,
	"./twitter.svg": 777,
	"./type-01.svg": 778,
	"./type-square.svg": 779,
	"./upload-cloud.svg": 780,
	"./user-add.svg": 781,
	"./user-plus-01.svg": 782,
	"./user-plus-02.svg": 783,
	"./user.svg": 784,
	"./users-01.svg": 785,
	"./web.svg": 786,
	"./whatsapp-color.svg": 787,
	"./whatsapp-fill.svg": 788,
	"./whatsapp.svg": 453,
	"./x-close.svg": 789,
	"./x-twitter.svg": 790,
	"./x.svg": 791,
	"./zoom-in.svg": 792,
	"./zoom-out.svg": 793
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 581;